import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"

const CopyButton = ({ className, children, copiedData }) => {
  const [showTooltipState, setShowTooltipState] = useState(false)
  const { t } = useTranslation()

  const directCopyToClipboard = (str) => {
    navigator.clipboard.writeText(str)
    setShowTooltipState(true)
    return false
  }

  useEffect(() => {
    if (showTooltipState) {
      setTimeout(() => {
        setShowTooltipState(false)
      }, "1000")
    }
  }, [showTooltipState])

  return (
    <div className="relative">
      <button
        className={`flex justify-center align-middle ${
          className?.length > 0 ? className : ""
        }`}
        onClick={(e) => {
          directCopyToClipboard(copiedData)
          e.preventDefault()
        }}
      >
        {children}
      </button>
      <span
        className={`absolute p-1 leading-none transition-opacity duration-300 transform -translate-x-1/2 bg-white border border-gray-300 pointer-events-none bottom-full left-1/2 text-primary-hover ${
          showTooltipState ? "" : "opacity-0"
        }`}
      >
        {t("generic.copy_button.copied")}
      </span>
    </div>
  )
}

export default CopyButton
